import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSubCategoryProducts } from '../../api/subCategoryProductApi';

export const getSubCategoryProducts = createAsyncThunk('subCategoryProducts/getSubCategoryProducts', async ({payload}, { rejectWithValue }) => {
  try {
    const response = await fetchSubCategoryProducts(payload);
    return response.data.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const subCategoryProductSlice = createSlice({
  name: 'subCategoryProducts',
  initialState: {
    subCategoryProducts: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSubCategoryProducts.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getSubCategoryProducts.fulfilled, (state, action) => {
        state.isLoading = false;
        state.subCategoryProducts = action.payload;
      })
      .addCase(getSubCategoryProducts.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default subCategoryProductSlice.reducer;
